import { getCatalogCategories } from '@/dashboards-v2/constants/catalog-categories.constants';
import { SET_DEFAULT_APP_WITH_CORE_EVENTS } from '@/dashboards-v2/constants/default-app';
import { PRODUCT_LINES } from '@/settings/subscription-settings/product-lines';
import { i18n_t as $t } from '@utils/i18n';

const DEFAULT_PES_DEFINITION = Object.freeze({
    dateRange: {
        timeSeries: {
            config: {
                type: 'Last 90 Days',
            },
            spec: {
                count: 90,
            },
        },
        type: 'Last 90 Days',
    },
    segmentId: 'everyone',
    account: {
        id: '',
        text: 'All Accounts',
    },
    appId: SET_DEFAULT_APP_WITH_CORE_EVENTS,
});
const getPesDefinition = ({ account, segmentId, timeSeries, appId } = {}) => ({
    ...DEFAULT_PES_DEFINITION,
    ...(account && { account }),
    ...(segmentId && { segmentId }),
    ...(appId && { appId }),
    ...(timeSeries && {
        dateRange: {
            type: timeSeries.config.type === 'Custom' ? timeSeries.label : timeSeries.config.type,
            timeSeries,
        },
    }),
});
const getPesSettingsBase = () =>
    Object.freeze({
        isCoreEvent: true,
        isPES: true,
        isPaidPendoOnly: true,
        categories: [getCatalogCategories().GENERAL],
        productLines: [[PRODUCT_LINES.ANALYTICS, 'pesEnabled']],
    });
const getPesBase = () =>
    Object.freeze({
        name: $t('pesWidget.Product Engagement Score (PES)'),
        type: 'productEngagementScore',
    });
const getPesTrendingBase = () =>
    Object.freeze({
        name: $t('pesWidget.Trending Product Engagement Score (PES)'),
        type: 'pesTrending',
    });

export const getPesWidgetCatalogSettings = () =>
    Object.freeze({
        ...getPesBase(),
        ...getPesSettingsBase(),
        image: 'product-engagement-score.png',
        description: $t(
            'pesWidget.Visualize PES (a composite score of adoption, stickiness, and growth) for a specific app, and drill down to understand how each of these are trending over time.',
        ),
        settings: getPesDefinition(),
        id: 'productEngagementScore',
    });

export const getPesTrendingWidgetCatalogSettings = () =>
    Object.freeze({
        ...getPesTrendingBase(),
        ...getPesSettingsBase(),
        image: 'pes-trending.png',
        description: $t(
            'pesWidget.Visualize how PES (a composite score of adoption, stickiness, and growth) for a specific app is trending over time and how each contributing metric is trending over time.',
        ),
        settings: getPesDefinition(),
        id: 'pesTrending',
    });

export const getDefaultPesWidget = (definitionOverrides = {}) => {
    return {
        ...getPesBase(),
        definition: getPesDefinition(definitionOverrides),
    };
};

export const getDefaultPesTrendingWidget = (definitionOverrides = {}) => {
    return {
        ...getPesTrendingBase(),
        definition: getPesDefinition(definitionOverrides),
    };
};
